import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import { useUser } from "../auth/useUser";
import { getDisplayName } from "../lib/displayName";
import type { components } from "../api/types";

type ProductSummary = components["schemas"]["ProductSummary"];

// useProducts is the founder's products list under the one ["products"] key
// (TanStack dedupes by key): the dashboard, the run provider, the run menu, the
// toast and the completion notifier read it, and it is read only while signed
// in. productName is a listed product's display name.
export function useProducts() {
  const { data: user } = useUser();
  return useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/api/v1/products");
      if (error) throw error;
      return data;
    },
    enabled: !!user,
  });
}

export function productName(products: readonly ProductSummary[] | undefined, productId: string): string {
  return getDisplayName((products ?? []).find((p) => p.id === productId));
}
